import { combineReducers } from 'redux';
import { routerReducer as routing } from 'react-router-redux';
import auth from './auth';
import layout from './layout';
import products from './products';
import catalogs from './catalogs';
import items from './items';
import options from './options';
import optiongroups from './optiongroups';
import taxrates from './taxrates';
import categories from './categories';
import admins from './admins';
import logs from './logs';
import settings from './settings';
import globalSettings from './globalSettings';
import salesChannels from './salesChannels';
import campaigns from './campaigns';
import orders from './orders';
import events from './events';
import discounts from './discounts';
import promotions from './promotions';
import giftCards from './giftCards';
import toprint from './toprint';
import articles from './articles';
import boxes from './boxes';
import overlays from './overlays';

const rootReducer = combineReducers({
  auth,
  articles,
  layout,
  products,
  catalogs,
  items,
  taxrates,
  options,
  optiongroups,
  categories,
  admins,
  logs,
  settings,
  globalSettings,
  salesChannels,
  campaigns,
  orders,
  events,
  discounts,
  promotions,
  giftCards,
  routing,
  toprint,
  boxes,
  overlays,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js